import classNames from 'classnames';
import { memo } from 'react';

import { TableCell } from '~/components/TableView/TableCell';
import { type CustomFieldTableHeaderProps } from './types';

export const CustomFieldTableHeader = memo(({ customFieldName, resizeHandle, style }: CustomFieldTableHeaderProps) => {
  return (
    <TableCell
      style={style}
      data-testid={customFieldName}
      data-disableselect="true"
      className={classNames('p-1.5 px-2 text-grey-11', !!resizeHandle && 'relative')}
    >
      {customFieldName}
      {resizeHandle}
    </TableCell>
  );
});
CustomFieldTableHeader.displayName = 'CustomFieldTableHeader';
